import { Dispatch } from "redux";
import { setSection } from "../QualificationDetailSlice";
import { SectionEnum } from "../../../common/enums/SectionEnum";
import { QualificationTypeEnum } from "../../../common/enums/QualificationTypeEnum";

interface Props {
    dispatch: Dispatch;
    amountAchievedCertificates?: number;
    amountEducators?: number;
    amountUnachievedEmployees?: number;
    qualificationType?: QualificationTypeEnum;
}

interface ReturnSection {
    title: string;
    onClick: () => void;
}

export const getSections = (props: Props): ReturnSection[] => {
    const {
        dispatch,
        amountAchievedCertificates,
        amountEducators,
        amountUnachievedEmployees,
        qualificationType,
    } = props;

    if (qualificationType === QualificationTypeEnum.ESTABLISHMENT) {
        return [
            {
                title: "Vestigingscertificaat",
                onClick: () =>
                    dispatch(
                        setSection({
                            name: SectionEnum.ESTABLISHMENTS_CERTIFICATE,
                            value: 0,
                        }),
                    ),
            },
        ];
    }

    return [
        {
            title:
                "Behaalde certificaten " +
                `(${amountAchievedCertificates || 0})`,
            onClick: () =>
                dispatch(
                    setSection({
                        name: SectionEnum.ACHIEVED_CERTIFICATES,
                        value: 0,
                    }),
                ),
        },
        {
            title: "Opleiders " + `(${amountEducators || 0})`,
            onClick: () =>
                dispatch(
                    setSection({
                        name: SectionEnum.EDUCATORS,
                        value: 1,
                    }),
                ),
        },
        {
            title: "Nog niet behaald " + `(${amountUnachievedEmployees || 0})`,
            onClick: () =>
                dispatch(
                    setSection({
                        name: SectionEnum.UNACHIEVED_CERTIFICATES,
                        value: 2,
                    }),
                ),
        },
    ];
};
